<template>
  <a :style="style" class="unalengua-logo depth" @click="navigateToMainSite"> <span>Unalengua</span> {{ $t('toolbar.ipa') }} {{ $t('toolbar.translator') }}</a>
</template>

<script>
  // import { Plugins } from '@capacitor/core';
  // const { Browser } = Plugins;

  export default {
    props: {
      fontSize: {
        type: Number,
        default: 18
      }
    },
    computed: {
      style(){
        return `font-size: ${this.fontSize}px`
      }
    },
    methods: {
      navigateToMainSite(){
        let url = `https://unalengua.com/${this.$i18n.locale}`;
        this.$window.location.href = url;
        // Browser.open({ url });
      }
    },
    created() {
      // Browser.prefetch({ url: `https://unalengua.com/${this.$i18n.locale}` });
    }
  }
</script>

<style lang="scss">
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;600&display=swap');

  .unalengua-logo {
    font-family: 'Montserrat', sans-serif;
    font-display: swap;
  }
  .depth {
    position: relative;
  }
  .depth:before, .depth:after {
      content: attr(title);
      color: rgba(255,255,255,.1);
      position: absolute;
  }
  .depth:before { top: 1px; left: 1px }
  .depth:after  { top: 2px; left: 2px }
</style>
